import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import * as Sentry from '@sentry/react-native';
import Loader from 'src/presentation/components/atoms/Loader';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import Colors from 'src/core/utils/Colors';

interface MigrationGateProps {
	children: React.ReactNode;
}

type GateState = 'migrating' | 'ready';

export default function MigrationGate({ children }: MigrationGateProps) {
	const [state, setState] = useState<GateState>('migrating');

	useEffect(() => {
		useServicesStore
			.getState()
			.migrate()
			.catch((error) => {
				Sentry.captureException(error, { tags: { context: 'migration-gate' } });
			})
			.finally(() => {
				setState('ready');
			});
	}, []);

	if (state === 'migrating') {
		return (
			<View style={{ flex: 1, backgroundColor: Colors.primary }}>
				<Loader bgColor={Colors.primary} message="Even je gegevens bijwerken..." />
			</View>
		);
	}

	return <>{children}</>;
}
